/* eslint-disable no-eval */
import { v4 as UUID } from 'uuid';
import apis from '../app/apis';
import cts, { cts_secure } from '../app/cts';
import store from '../configureStore';
import { setDistrictsArray } from '../helpers';

import { setCollectionSchedule } from '../pages/ZoneSetupScreens/utils';

import {
  plugin, config, zone, education, quiz
} from '../redux/actions';
import { setBPItems } from '../pages/BulkPickup/redux/actions';
import { setPrompts } from '../redux/actions/zone';

import { modifyQuizData } from '../helpers/quiz';

const { dispatch } = store.store;

const {
  setUuid,
  setPluginId,
  setProjectId,
  setEncodePluginId,
  setXGW,
} = plugin;

const {
  setLangs,
  setTitle,
  setCountryCode,
  setDistrictId,
  setLocalityId,
  setDefaultLang,
  setSelectedLang,
  setTemplateColour,
  setIsMultiDistrict,
  setIsActive,
  setWebappConfiguration,
  setShouldSeeDistrictSelector,
} = config;

const {
  setZoneAry,
  setZoneStr,
  setCountryName,
} = zone;

const {
  setEducationData
} = education;

const {
  setQuizData
} = quiz;

const downloadPackage = async (plugin) => {
  try {
    const { data, status } = await cts('get', apis.getPluginDetails(plugin.plugin_id, plugin.lang_cd));

    if (
      !data
      && !Object.keys(data).length
      && status !== 200
    ) throw new Error('There was a problem in downloading the plugin data.');

    return Promise.resolve(data);
  } catch (e) {
    return Promise.reject(e.message);
  }
};

const trackerSystem = async (plugin) => {
  try {
    cts_secure('post', apis.sendPluginTracker(), plugin);
  } catch (e) {
    console.log('error in tracker');
  }
};

const convertLangLabel = (langs) => {
  if (!langs) return {};
  const lngs = Object.entries(langs).map((lang) => {
    const { lang_cd, display_nm } = lang[1];
    return {
      label: display_nm.replace(/Australian|British|Canadian|American|New Zealand|\(default\)/ig, '').trim(),
      lang_cd
    };
  });
  return lngs;
};

const Setup = async (pluginID) => {
  try {
    const { plugin, config, zone } = store.store.getState();
    const { uuid, projectId, storeDistricts } = plugin;
    const { zoneStr } = zone;
    const { selectedLang, districtId: district } = config;

    const pluginPackage = await downloadPackage({ plugin_id: pluginID, lang_cd: selectedLang || 'en' });

    if (
      !pluginPackage
      && !Object.keys(pluginPackage).length
    ) throw new Error('There was a problem in downloading the package data.');

    // Rehydrated and has data
    if (district && projectId && zoneStr) await setCollectionSchedule(zoneStr);

    dispatch(setEncodePluginId(pluginID));
    if (!uuid) {
      dispatch(setUuid(UUID()));
    }

    const {
      langs = [],
      title = '',
      plugin_id = '',
      country_nm = '',
      custom_URL = '',
      country_cd = 'CA',
      tab_properties = {},
      template_colour = '',
      default_language = 'en_US',
      districts: rawDistricts = [],
      is_active = true,
      has_bulk_pickup = false,
      bulk_pickup_title = '',
      dz_custom_config = {},
      has_dz_custom_config = false,
      x_gw = '',
      app_brand = '',
      app_download_android_link = '',
      app_download_branded_app = 0,
      app_download_ios_link = '',
      app_download_logo = '',
      app_download_message_long = '',
      app_download_message_short = '',
      app_download_qr_code = '',
      app_privacy_policy_link = '',
    } = pluginPackage;

    if (
      Object.keys(tab_properties).length
      && tab_properties.custom_js
    ) {
      const timer = setTimeout(() => {
        // eslint-disable-next-line no-eval
        eval(`(async () => {${tab_properties.custom_js.replace(/\n/ig, '')}})()`);
      }, 1000);
    } else {
      // Check if the plugin is in a website created by CivicPlus.
      // If so, adjust the height of the plugin to fit the content.
      setTimeout(() => {
        const civicPlusFooterLink = document?.querySelector('a[href="https://connect.civicplus.com/referral"]');
        const civicPlusInput = document?.querySelector('input#cpcDomain');
        const isCivicPlusSite = civicPlusFooterLink || civicPlusInput;

        if (isCivicPlusSite) {
          const style = document.createElement('style');
          style.type = 'text/css';
          style.innerHTML = '.height_resizer { height: auto !important; }';
          document.getElementsByTagName('head')[0].appendChild(style);
          const el = document.getElementById('rcroot');
          const closest1 = el.closest('div.outer.col.col24.first.last > div.row.nest.first.last.wide > div.inner.col.col24.first.last');
          const closest2 = el.closest('div.outer.col.col24.first.last > div.row.nest.wide > div.inner.col.col24.first.last');
          if (closest1) closest1.className = 'height_resizer';
          if (closest2) closest2.className = 'height_resizer';
        }
      }, 1000);
    }

    // event tracker system: for getting clients URL
    await trackerSystem({ plugin_url: custom_URL, url: window.location.href });

    /* Check for multi districts */
    const isMultiDistrict = (rawDistricts && rawDistricts.length > 1) || false;
    dispatch(setIsMultiDistrict(isMultiDistrict));

    /** Set country code. */
    dispatch(setCountryCode(country_cd || 'CA'));
    dispatch(setIsActive(is_active));
    /* Determines if all the zone setup options are equal to address-search */
    const shouldNotSeeDistrictSelector = rawDistricts
      .map(({ prompts }) => prompts.length && prompts[0].zoneSelectOptions)
      .every(({ search }) => !!(search));
    if (isMultiDistrict) dispatch(setShouldSeeDistrictSelector(!shouldNotSeeDistrictSelector));
    const firstProjectId = rawDistricts[0]?.project_id;
    const shouldCallMultipApi = !rawDistricts
      .every((i) => i?.project_id === firstProjectId);
    /**
     * First transform the districts from array to object
     * second find out if we select district before or not
     */
    const districts = rawDistricts.reduce((prev, cur) => {
      const newItem = prev;
      newItem[cur.district_id] = cur;
      return newItem;
    }, {});
    const districtId = setDistrictsArray(
      districts,
      rawDistricts.length === 1 // OR if it's single district
        ? Object.keys(districts)[0] // use the first district
        : district,
      tab_properties.has_calendar

    );
    if (
      isMultiDistrict
      && (
        Object.keys(districts).length !== Object.keys(storeDistricts).length
        || JSON.stringify(districts) !== JSON.stringify(storeDistricts)
      )
    ) {
      dispatch(setZoneStr(''));
      dispatch(setZoneAry([]));
      dispatch(setDistrictId(''));
      dispatch(setLocalityId(''));
      dispatch(setSelectedLang(default_language || 'en_US'));
      // Setup(pluginID);
    }

    if (
      !isMultiDistrict
      && (
        Object.keys(districts).length !== Object.keys(storeDistricts).length
        || JSON.stringify(districts) !== JSON.stringify(storeDistricts)
      )
    ) {
      dispatch(setZoneStr(''));
      dispatch(setZoneAry([]));
    }

    if (
      langs
      && langs.length
    ) dispatch(setLangs(convertLangLabel(langs)));

    dispatch(setTitle(title));
    dispatch(setPluginId(plugin_id));
    if (!shouldCallMultipApi || !shouldNotSeeDistrictSelector) {
      dispatch(setProjectId(rawDistricts[0].project_id) || '');
    }
    dispatch(setCountryName(country_nm || ''));
    dispatch(setDefaultLang(default_language));
    dispatch(setTemplateColour(template_colour));
    dispatch(setWebappConfiguration({
      ...tab_properties,
      has_bulk_pickup,
      bulk_pickup_title,
      has_dz_custom_config,
      dz_custom_config: dz_custom_config || {},
      app_brand,
      app_download_android_link,
      app_download_branded_app,
      app_download_ios_link,
      app_download_logo,
      app_download_message_long,
      app_download_message_short,
      app_download_qr_code,
      app_privacy_policy_link
    }));

    /**
    * Set Education tab data for selected district
    */

    if (districtId) {
      const educationData = pluginPackage.districts
        .find((item) => item.district_id === districtId).education_tab_elements;

      const quizData = modifyQuizData(educationData);

      dispatch(setQuizData(quizData));
      dispatch(setEducationData(educationData));
    }

    dispatch(setXGW(x_gw));
    return Promise.resolve('done');
  } catch (e) {
    return Promise.reject(e);
  }
};

export default Setup;

export const bpOnlySetup = async () => {
  try {
    const searchParams = new URLSearchParams(window.location.search);
    const projectId = searchParams.get('project_id');
    const districtId = searchParams.get('district_id');
    const fullAddressBpOnly = searchParams.get('full_address');
    const zoneStringBpOnly = searchParams.get('zone_string');
    if (!projectId || !districtId) throw new Error('There was a problem in downloading the plugin data.');

    const { data, status } = await cts('get', apis.getPluginDetailsBpOnly(projectId, districtId));
    if (
      !data
      && !Object.keys(data).length
      && status !== 200
    ) throw new Error('There was a problem in downloading the plugin data.');

    dispatch(setWebappConfiguration({
      has_bulk_pickup: data.has_bulk_pickup,
      bulk_pickup_title: data.bulk_pickup_title,
      feature: 'bulk_pickup',
      fullAddressBpOnly: decodeURIComponent(fullAddressBpOnly),
      zoneStringBpOnly
    }));

    const districtData = data.districts.find((i) => i.district_id === districtId);

    dispatch(setPrompts(districtData.prompts));
    dispatch(setBPItems(districtData.help_items.find((item) => item.type === 'PICKUP_REQUEST')));
    dispatch(setDistrictId(districtData.district_id));
    dispatch(setProjectId(districtData.project_id));
    dispatch(setSelectedLang('en'));
    return Promise.resolve('done');
  } catch (e) {
    return Promise.reject(e.message);
  }
};
